/**
 *
 * Card mit Button für das Fetchen der Statistik
 *
 */


import React from "react";
import { IonCardHeader, IonCard, IonGrid, IonRow, IonCol, IonCardTitle, IonButton, IonCardContent } from "@ionic/react";

type ApplyFilterCardProps = {
    filterCount?: number,
    applyFilter: () => void,
    resultSet?: number,
    fromCompressedView?: boolean,
}

const ApplyFilterCard: React.FC<ApplyFilterCardProps> = ({ filterCount, applyFilter, resultSet, fromCompressedView }: ApplyFilterCardProps) => {

    return (
        <IonCard className="normalCard">
            <IonCardContent>
                <IonGrid className="noPaddingGrid">
                    <IonRow /* className="ion-align-items-center ion-justify-content-evenly" style={{width: "100%"}} */>
                        <IonCol size="12" sizeSm="6" className="ion-no-padding">
                            <IonCardTitle className="cardTitle ">Filter anwenden{filterCount && "*"}</IonCardTitle>
                            {filterCount &&<div>*maximal {filterCount} Datenreihen in Graph darstellbar</div>}
                        </IonCol>
                        <IonCol size="12" sizeSm="6" className="ion-no-padding">
                            <IonButton className="ion-float-right" type="submit" onClick={applyFilter}>Diagramm {fromCompressedView ? "aktualisieren" : "anzeigen"}</IonButton>
                        </IonCol>
                    </IonRow>
                    {resultSet > filterCount &&
                        <IonRow>
                            <IonCol className="ion-no-padding">
                                <div style={{ color: "var(--ion-color-secondary)" }}>Warnung: Die Ergebnismenge beläuft sich auf {resultSet} Datenreihen.</div>
                            </IonCol>
                        </IonRow>
                    }
                </IonGrid>
            </IonCardContent>
        </IonCard>
    )
}

export default ApplyFilterCard;